export type CreateReceiveExceptionRequest = {
  exceptionType: string;
  title: string;
  site: string | null;
  quantity: number | null;
  shipmentReferenceId: string | null;
  orderType: string;
  orderNumber: string;
  trackingNumber: string | null;
  holdingLocation: string;
  model: string | null;
  legacyModelId: string | null;
  serials: string[];
  orderLineNumber: string | null;
  note: string | null;
  tags: string[];
};

export type UpdateReceiveExceptionRequest = {
  exceptionId: string;
  title: string;
  site: string;
  quantity: number;
  trackingNumber: string;
  holdingLocation: string;
  serials: string[];
  tags: string[];
  status: ReceiveExceptionStatus;
  assignedTo: string;
  resolutionCode: string;
  resolutionNote: string;
  resolver: string;
};

export type ReceiveException = {
  id: string;
  exceptionId: string;
  version: string;
  title: string;
  exceptionType: string;
  locationId: string;
  site: string;
  quantity: number;
  shipmentReferenceId: string;
  orderType: string;
  orderNumber: string;
  trackingNumber: string;
  holdingLocation: string;
  model: string;
  legacyModelId: string;
  serials: string[];
  orderLineNumber: number;
  tags: string[];
  status: ReceiveExceptionStatus;
  assignedToId: string;
  assignedToType: string;
  resolutionCode: string | null;
  resolutionNote: string | null;
  resolver: string | null;
  createdAt: string;
  createdBy: string;
  updatedAt: string | null;
  updatedBy: string | null;
};

export enum ReceiveExceptionStatus {
  ASSIGNED = 'ASSIGNED',
  CANCELLED = 'CANCELLED',
  PENDING_ACTION = 'PENDING_ACTION',
  RESOLVED = 'RESOLVED',
}

export type ReceiveExceptionNote = {
  id: string;
  note: string;
  createdAt: string;
  createdBy: UserIdentity;
};

export type UserIdentity = {
  contact: string;
};

export enum RECEIVE_EXCEPTION_ASSIGNEE_TYPE {
  EMAIL = 'EMAIL',
  LDAP_USER = 'LDAP_USER',
  RESOLVER_GROUP = 'RESOLVER_GROUP',
}
